import { Component, Input } from '@angular/core';

import { RfaFormControl, RfaValidators } from '../../../level1';
import { valueChangeOptionsToConfig } from '../../helpers/tracker-options-to-config';
import type { RfaComponents } from '../RfaComponents';
import type { RfaValueChangeTrackerOptions } from '../../models/rfa-tracker-options.interface';

@Component({
  selector: 'rfa-select',
  templateUrl: './rfa-select.component.html',
  styleUrls: ['./rfa-select.component.scss'],
})
export class RfaSelectComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) control!: RfaFormControl<
    (typeof RfaComponents.Select)['valueType'],
    typeof RfaComponents.Select
  >;

  protected readonly defaultEmptyValueText = '';

  get showOptional(): boolean {
    return !this.control.hasValidator(RfaValidators.required);
  }

  valueChangeTrackConfig() {
    const valueChangeOptions: RfaValueChangeTrackerOptions =
      this.control.options.analytics?.valueChangeTracker ?? {};

    return valueChangeOptionsToConfig(
      {
        ...valueChangeOptions,
        value: this.control.value.toString(),
      },
      {
        fieldName: this.control.options.label,
        hashValue: false,
      }
    );
  }
}
